module.exports = __webpack_public_path__ + "assets/retina_SquareInCircleDetailed.0498041787459846ffd54fb7c22c3595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_SquareInCircleDetailed.png
// module id = 722
// module chunks = 0